import ReactGA from "react-ga4";

export const initGA = () => {
  ReactGA.initialize("G-1N4VRRVGE2");
};

export const trackPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};